import {AxiosRequestConfig, AxiosResponse, default as axios} from 'axios';

class HttpService
{
	get(uri: string, request?: AxiosRequestConfig, maxAttempts?: number): Promise<AxiosResponse>
	{
		if (maxAttempts === undefined)
		{
			maxAttempts = 3;
		}

		return new Promise(function (resolve: Function, reject: Function)
		{
			let attempts = 0;

			let attempt = function ()
			{
				axios.get(uri, request)
					 .then(function (response)
					 {
						 resolve(response);
					 })
					 .catch(function (error)
					 {
						 if (error.response)
						 {
							 if (error.response.status > 500 || ++attempts > (maxAttempts as number))
							 {
								 reject(error);
							 }
							 else
							 {
								 setTimeout(attempt, 1000);
							 }
						 }
						 else
						 {
							 reject(error);
						 }
					 });
			};

			attempt();
		});
	}

	postForm(uri: string, form: HTMLFormElement): Promise<AxiosResponse>
	{
		return new Promise(function (resolve: Function, reject: Function)
		{
			axios.post(uri, new FormData(form))
				 .then(function (response)
				 {
					 resolve(response);
				 })
				 .catch(function (error)
				 {
					 reject(error);
				 });
		});
	}
}

export const Http = new HttpService();

export default { Http };
